import React, {useState, useEffect} from 'react'
import { NavLink, Link, useNavigate } from "react-router-dom";
import {BrowserView, MobileView} from 'react-device-detect';
import axios from "axios";

const Header = () =>{
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const [data, setData] = useState()
  const [searchQuery, setSearchQuery] = useState('');
  const navigate = useNavigate();  
  const apiUrl = apiBaseUrl+`company`;

  const fetchHeaderInfo = () => {
    try{
        return axios.get(apiUrl).then((res) => {
        setData(res.data.company)
        //console.log(res.data.company);
        });
    }catch(err){
        console.log(err);
    }
  };

    // Sticky Menu Area
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });

    const isSticky = (e) => {
        const header = document.querySelector('.header-wrapper');
        const topbar = document.querySelector('.top-bar');
        const scrollTop = window.scrollY;
        if(scrollTop >= 100){
            topbar.classList.add('stuck');
            header.classList.add('headerstuck');
         }else{
            topbar.classList.remove('stuck');
            header.classList.remove('headerstuck');
         } 
    };

    const headerScrollToTop = () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth' // Optional, for smooth scrolling
        });
    };

    useEffect(() => {
        //fetchHeaderInfo();
        setTimeout(() => {fetchHeaderInfo();}, 2000);
    }, []);


  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    navigate(`/search/${searchQuery}`);
  };
  const handleChange = (event) => {
    setSearchQuery(event.target.value);
  };

  return (
    <>
    <header className="main-header clearfix">
        <div className="top-bar">
            <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12 text-left"></div>
                    <div className="col-lg-6 col-md-6 text-right">
                        <ul className="top-bar-info clearfix">
                            <li><Link to={`tel:${data?.customer_care_number}`}>Customer Care: {data?.customer_care_number}</Link></li>
                            <li><Link to="/download-certificates" onClick={headerScrollToTop}> Download</Link></li>
                        </ul>
                        <div className="top-bar-social">
                            <Link to={data?.linkedin} target="_blank"><i className="fa fa-linkedin-square"></i></Link>
                            <Link to={data?.facebook} target="_blank"><i className="fa fa-facebook"></i></Link>
                            <Link to={data?.twitter} target="_blank">
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 640"><path d="M453.2 112L523.8 112L369.6 288.2L551 528L409 528L297.7 382.6L170.5 528L99.8 528L264.7 339.5L90.8 112L236.4 112L336.9 244.9L453.2 112zM428.4 485.8L467.5 485.8L215.1 152L173.1 152L428.4 485.8z"/></svg>
                            </Link>                            
                            <Link to={data?.instagram} target="_blank"><i className="fa fa-instagram"></i></Link>
                            <Link to={data?.youtube} target="_blank"><i className="fa fa-youtube"></i></Link>
                        </div>
                    </div>
                 </div>
            </div>
        </div>

        <section className="header-wrapper navgiation-wrapper ">
            <div className="navbar navbar-default">			
                <div className="container">
                  <div className="row text-center">
                    <div className="navbar-header">
                        <button type="button" className="navbar-toggle" data-toggle="collapse" data-target=".navbar-collapse">
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                            <span className="icon-bar"></span>
                        </button>
                        <Link to="/" className='logo' onClick={headerScrollToTop}>
                            <img alt={data?.company_name} src="/images/logo.png" />
                        </Link>
                    </div>
                    
                    <div className="navbar-collapse collapse">
                        <ul className="nav navbar-nav navbar-center">
                            <li className="drop">
                                <NavLink exact="true" activeclassname="active" to='/about-us' onClick={headerScrollToTop}>About Us</NavLink>
                                <BrowserView>
                                <ul className="drop-down">
                                    <li><a href="#essence">Our Essence</a></li>
                                    <li><a href="#vision">⁠Vision & Mission</a></li>
                                    <li><a href="#story">⁠Our Story</a></li>
                                    <li><a href="#minds">⁠⁠Minds Behind</a></li>
                                    <li><a href="#case-study">⁠Case Studies</a></li>
                                    <li><a href="#reach">Our Reach</a></li>
                                </ul>
                                </BrowserView>
                                <MobileView>
                                <ul className="drop-down">
                                    <li><NavLink activeclassname="active" to="/about/essence" onClick={headerScrollToTop}>Our Essence</NavLink></li>
                                    <li><NavLink activeclassname="active" to="/about/vision" onClick={headerScrollToTop}>⁠Vision & Mission</NavLink></li>
                                    <li><NavLink activeclassname="active" to="/about/milestone" onClick={headerScrollToTop}>⁠Our Story</NavLink></li>
                                    <li><NavLink activeclassname="active" to="/about/minds" onClick={headerScrollToTop}>⁠⁠Minds Behind</NavLink></li>
                                    <li><NavLink activeclassname="active" to="/about/case-studies" onClick={headerScrollToTop}>Case Studies</NavLink></li>
                                    <li><NavLink activeclassname="active" to="/about/reach" onClick={headerScrollToTop}>Our Reach</NavLink></li>
                                </ul>                                    
                                </MobileView>
                            </li>
                            <li className="drop">
                                <NavLink activeclassname="active" to='/products' onClick={headerScrollToTop}>Products</NavLink>
                                <BrowserView>
                                    <ul className="drop-down">
                                        <li><a title="Solar Module" href="#solar-module">Solar Module</a></li>
                                        <li><a title="Solar Cell" href="#solar-cell">Solar Cell</a></li>
                                        <li><a title="Mounting Structure" href="#mounting-structure">Mounting Structure</a></li>                                    
                                    </ul>                                
                                </BrowserView>
                                <MobileView>
                                    <ul className="drop-down">
                                        <li><NavLink activeclassname="active" to="/product/solar-module" onClick={headerScrollToTop}>Solar Module</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/product/solar-cell" onClick={headerScrollToTop}>Solar Cell</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/product/mounting-structure" onClick={headerScrollToTop}>Mounting Structure</NavLink></li>                                    
                                    </ul>
                                </MobileView>

                            </li>
                            <li className="drop">
                                <NavLink activeclassname="active" to='/solutions' onClick={headerScrollToTop}>Solutions</NavLink>
                                <BrowserView>
                                    <ul className="drop-down">
                                        <li><a href="#residential">Residential</a></li>
                                        <li><a href="#housing">Housing Societies</a></li>
                                        <li><a href="#ci">⁠C&I</a></li>
                                        <li><a href="#⁠institutional">⁠Institutional</a></li>
                                        <li><a href="#powerplants">⁠⁠Mega Power Plants</a></li>
                                        <li><a href="#aftercare">After Care</a></li>
                                    </ul>                                   
                                </BrowserView>
                                <MobileView>
                                    <ul className="drop-down">
                                        <li><NavLink activeclassname="active" to="/solution/section/residential" onClick={headerScrollToTop}>Residential</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/solution/section/housing" onClick={headerScrollToTop}>Housing Societies</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/solution/section/ci" onClick={headerScrollToTop}>⁠C&I</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/solution/section/institutional" onClick={headerScrollToTop}>⁠Institutional</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/solution/section/powerplants" onClick={headerScrollToTop}>⁠⁠Mega Power Plants</NavLink></li>
                                        <li><NavLink activeclassname="active" to="/solution/section/aftercare" onClick={headerScrollToTop}>After Care</NavLink></li>
                                    </ul>                                     
                                </MobileView>
                            </li>
                            <li>
                                <NavLink 
                                    to="/careers"
                                    onClick={headerScrollToTop}
                                    activeclassname="active"
                                    >Careers
                                </NavLink >                                 
                            </li>
                            <li>
                                <NavLink 
                                    to="/blog"
                                    onClick={headerScrollToTop}
                                    activeclassname="active"
                                    >Blog
                                </NavLink >                                 
                            </li>
                            <li className='hidden-md hidden-lg visible-sm visible-xs'>
                                <NavLink 
                                    to="/contact"
                                    onClick={headerScrollToTop}
                                    activeclassname="active"
                                    >Contact Us
                                </NavLink >                                 
                            </li> 
                        </ul>
                    </div>
                    
                    <div className="navbar-bottom navbar-right">
                        <form className="search-form" onSubmit={handleSubmit}>
                            <div className="input-group">
                                <input 
                                    className="form-control" 
                                    placeholder="Search...." 
                                    type="text" 
                                    name="srch"
                                    value={searchQuery}
                                    onChange={handleChange}
                                    autoComplete="false"                            
                                    required/>
                                <span className="input-group-addon"><i className="fa fa-search"></i></span>
                            </div>
                        </form>
                        <div className="download"><Link to="/contact" onClick={headerScrollToTop}>Contact Us</Link></div>
                    </div>
                        
                </div>	
                </div>
            </div>
            
        </section>
    </header>  

    <div className="whatsapp-share">
        <Link to={`https://wa.me/${data?.whatsapp_number}`} target="_blank">
            <img class="logo-main" src="/images/whatsappbtn.png" alt="whatsapp" />
        </Link>
    </div>    
    </>
  )
}

export default Header